import React, {useState} from 'react';
import moment from 'moment';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import ButtonAction from '../../../../_common/components/ButtonAction';
import FieldInput from '../../../../_common/components/FieldInput';
import {DatePicker} from '../../../../_common/components/FieldDatepicker';
import {floatValue} from '../../../../../../utils/format';
import styles from '../styles.module.scss';

const RowCheque = ({
                     setFieldValue,
                     fieldsSet,
                     removeRow
                   }) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className={styles.chequeRowContainer}>
      <DatePicker
        value={startDate}
        onChange={(date) => {
          setStartDate(date);
          setFieldValue(fieldsSet.date, date);
        }}
        minDate={moment().subtract(1, 'months').format('YYYY-MM-DD')}
        maxDate={moment().add(1, 'years').format('YYYY-MM-DD')}
      />
      <FieldInput fieldId={fieldsSet.bankName}/>
      <FieldInput fieldId={fieldsSet.bankBranch}/>
      <FieldInput fieldId={fieldsSet.bankAccount}/>
      <FieldInput fieldId={fieldsSet.chequeNum}/>
      <FieldInput fieldId={fieldsSet.price} onChange={floatValue}/>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        onClick={removeRow}
        label={<img src={toAbsoluteUrl('/media/common/Delete_red.svg')} alt="delete"/>}
        customClassnames={'mr-4 ml-auto'}
        avoidDoubleClick={false}
      />
    </div>
  );
};

export default RowCheque;